import { styled } from '@mui/material'

export const AuthHeader = styled('div')`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 16px 0;
`
